import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import getters from './getters'

import permission from './modules/permission'
import login from './modules/login'
import account from './modules/account'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    login,
    permission,
    account,
  },
  getters
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js